import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link } from 'react-router-dom'
import { Modal } from 'react-bootstrap';

import { getCookie } from '../common_component/cookie.js';
import StatusBadge from '../common_component/StatusBadge.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import { Pagination, Tooltip } from 'antd';

export const EcommerceItemList = () => {
    const [state, setstate] = useState(2);
    const [itemList, setItemList] = useState([])

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null)
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [itemsListApiState, setEcommerceItemsListApiState] = useState(false);

    const [statusModalShow, setStatusModalShow] = useState(false);
    const [statusProductId, setStatusProductId] = useState(null);
    const [status, setStatus] = useState(null);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [marketingInfoModalShow, setMarketingInfoModalShow] = useState(false)
    const [marketingInfoApiState, setMarketingInfoApiState] = useState(false)
    const [selectedMarketingInfoProductId, setSelectedMarketingInfoProductId] = useState(null)
    const [ecommb2b, setEcommb2b] = useState(false)
    const [ecommb2c, setEcommb2c] = useState(false)
    const [marketingInfoModalSubmitButtonState, setMarketingInfoModalSubmitButtonState] = useState(false)

    var page_name = "ecommerce-item-list";

    const apiController = useRef(new AbortController())

    const { user, read, write, visibility, organization_id } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getEcommerceItemList(cp, rpp, sort_c, sort_v, search_v) {
        setEcommerceItemsListApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-item-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "organization_id": organization_id, "current_page": cp - 1, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            var temp_data = [];
            body.data.list.map((obj) => {
                var temp_obj = {};
                temp_obj.product_id = obj.product_id;
                temp_obj.product_name = obj.product_name;
                temp_obj.category_name = obj.category_name;
                temp_obj.subcategory_name = obj.subcategory_name;
                temp_obj.brand_name = obj.brand_name;
                temp_obj.b2b = obj.b2b;
                temp_obj.b2c = obj.b2c;

                temp_obj.add_status = obj.add_status;

                let id = obj.product_id;

                temp_obj.actions = <div className="dropdown">
                    <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                    {
                        write &&
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li className="py-1"><Link to={`/edit-item/${id}`} className="dropdown-item">Edit details</Link></li>
                            <li className="py-1"><div className="dropdown-item" style={{ cursor: "pointer" }} onClick={(e) => { setStatusProductId(id); setStatus(obj.add_status); setStatusModalShow(true); }} >Change status</div></li>
                            <li className="py-1"><Link to={`/item-price-information/${id}`} className="dropdown-item" >Add/Edit price</Link></li>
                            <li className="py-1"><Link to={`/item-stock-information/${id}`} className="dropdown-item">Add/Edit stock</Link></li>
                            <li className="py-1"><Link to={`/item-images/${id}`} className="dropdown-item">Add/Edit product image</Link></li>
                            <li className="py-1"><Link to={`/item-videos/${id}`} className="dropdown-item">Add/Edit product video</Link></li>
                            <li className="py-1"><Link to={`/configure-ecommerce-item-info/${id}`} className="dropdown-item">Configure product E-Commerce Info</Link></li>
                            <li className="py-1"><div className="dropdown-item" style={{ cursor: "pointer" }} onClick={(e) => { getProductMarketingInfo(id); setSelectedMarketingInfoProductId(id); setMarketingInfoModalShow(true); }} >Configure product Marketing info</div></li>
                        </ul>
                    }
                </div>
                temp_data.push(temp_obj);
            })
            setItemList(temp_data);
            setListCount(body.data.count);
            setEcommerceItemsListApiState(false);
        }
    }

    async function getProductMarketingInfo(pid) {
        setMarketingInfoApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-product-marketing-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "product_id": pid, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            setMarketingInfoApiState(false)
            if (body.data != null) {
                setEcommb2b(body.data.b2b)
                setEcommb2c(body.data.b2c)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getEcommerceItemList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue);

            Promise.all([p1])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getEcommerceItemList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue)
        }
    }, [currentPage, rowsPerPage, sortColumn, sortValue, searchValue])

    const submitStatus = (e) => {

        var values = {
            "product_id": statusProductId,
            "status": status == "Active" ? "Deactivated" : "Active",
            "page_name": page_name,
            "organization_id": organization_id
        };

        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-ecommerce-item-status`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            handleStatusModalClose()
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Status changed successfully!", "success")
                getEcommerceItemList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue);
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        });
    }
    const handleStatusModalClose = () => {
        setStatusModalShow(false)

        setStatusProductId(null)
        setStatus(null)
    }

    const configureProductMarketingInfoSubmit = () => {

        var object = {};

        object.product_id = selectedMarketingInfoProductId
        object.b2b = ecommb2b
        object.b2c = ecommb2c

        object.organization_id = organization_id;
        object.page_name = page_name;

        setMarketingInfoModalSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/configure-product-marketing-info`, object, headers).then((res) => {
            setMarketingInfoModalSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Product Marketing Info configured successfully!", "success")
                handleMarketingInfoModalClose()
                getEcommerceItemList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue)
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleMarketingInfoModalClose = () => {
        setMarketingInfoModalShow(false)

        setSelectedMarketingInfoProductId(null)
        setEcommb2b(false)
        setEcommb2c(false)
    }

    const getStatus = (status) => {
        if (status == true) {
            return (
                <svg width="24" height="24" viewBox="0 0 122.88 122.88" >
                    <path fill="#00A912" d="M34.388,67.984c-0.286-0.308-0.542-0.638-0.762-0.981c-0.221-0.345-0.414-0.714-0.573-1.097 c-0.531-1.265-0.675-2.631-0.451-3.934c0.224-1.294,0.812-2.531,1.744-3.548l0.34-0.35c2.293-2.185,5.771-2.592,8.499-0.951 c0.39,0.233,0.762,0.51,1.109,0.827l0.034,0.031c1.931,1.852,5.198,4.881,7.343,6.79l1.841,1.651l22.532-23.635 c0.317-0.327,0.666-0.62,1.035-0.876c0.378-0.261,0.775-0.482,1.185-0.661c0.414-0.181,0.852-0.323,1.3-0.421 c0.447-0.099,0.903-0.155,1.356-0.165h0.026c0.451-0.005,0.893,0.027,1.341,0.103c0.437,0.074,0.876,0.193,1.333,0.369 c0.421,0.161,0.825,0.363,1.207,0.604c0.365,0.231,0.721,0.506,1.056,0.822l0.162,0.147c0.316,0.313,0.601,0.653,0.85,1.014 c0.256,0.369,0.475,0.766,0.652,1.178c0.183,0.414,0.325,0.852,0.424,1.299c0.1,0.439,0.154,0.895,0.165,1.36v0.23 c-0.004,0.399-0.042,0.804-0.114,1.204c-0.079,0.435-0.198,0.863-0.356,1.271c-0.16,0.418-0.365,0.825-0.607,1.21 c-0.238,0.377-0.518,0.739-0.832,1.07l-27.219,28.56c-0.32,0.342-0.663,0.642-1.022,0.898c-0.369,0.264-0.767,0.491-1.183,0.681 c-0.417,0.188-0.851,0.337-1.288,0.44c-0.435,0.104-0.889,0.166-1.35,0.187l-0.125,0.003c-0.423,0.009-0.84-0.016-1.241-0.078 l-0.102-0.02c-0.415-0.07-0.819-0.174-1.205-0.31c-0.421-0.15-0.833-0.343-1.226-0.575l-0.063-0.04 c-0.371-0.224-0.717-0.477-1.032-0.754l-0.063-0.06c-1.58-1.466-3.297-2.958-5.033-4.466c-3.007-2.613-7.178-6.382-9.678-9.02 L34.388,67.984L34.388,67.984z M61.44,0c16.96,0,32.328,6.883,43.453,17.987c11.104,11.125,17.986,26.493,17.986,43.453 c0,16.961-6.883,32.329-17.986,43.454C93.769,115.998,78.4,122.88,61.44,122.88c-16.961,0-32.329-6.882-43.454-17.986 C6.882,93.769,0,78.4,0,61.439C0,44.48,6.882,29.112,17.986,17.987C29.112,6.883,44.479,0,61.44,0L61.44,0z M96.899,25.981 C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685c-9.073,9.073-14.684,21.609-14.684,35.458 c0,13.851,5.611,26.387,14.684,35.46s21.609,14.685,35.46,14.685c13.85,0,26.386-5.611,35.459-14.685s14.684-21.609,14.684-35.46 C111.583,47.59,105.973,35.054,96.899,25.981L96.899,25.981z" />
                </svg>
            )
        }
        else {
            return (
                <svg width="24" height="24" viewBox="0 0 122.88 122.879">
                    <path fill="#EB0110" d="M61.44,0c16.96,0,32.328,6.882,43.453,17.986c11.104,11.125,17.986,26.494,17.986,43.453 c0,16.961-6.883,32.328-17.986,43.453C93.769,115.998,78.4,122.879,61.44,122.879c-16.96,0-32.329-6.881-43.454-17.986 C6.882,93.768,0,78.4,0,61.439C0,44.48,6.882,29.111,17.986,17.986C29.112,6.882,44.48,0,61.44,0L61.44,0z M73.452,39.152 c2.75-2.792,7.221-2.805,9.986-0.026c2.764,2.776,2.775,7.292,0.027,10.083L71.4,61.445l12.077,12.25 c2.728,2.77,2.689,7.256-0.081,10.021c-2.772,2.766-7.229,2.758-9.954-0.012L61.445,71.541L49.428,83.729 c-2.75,2.793-7.22,2.805-9.985,0.025c-2.763-2.775-2.776-7.291-0.026-10.082L51.48,61.435l-12.078-12.25 c-2.726-2.769-2.689-7.256,0.082-10.022c2.772-2.765,7.229-2.758,9.954,0.013L61.435,51.34L73.452,39.152L73.452,39.152z M96.899,25.98C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685 c-9.073,9.073-14.684,21.609-14.684,35.459s5.611,26.387,14.684,35.459c9.073,9.074,21.609,14.686,35.46,14.686 c13.85,0,26.386-5.611,35.459-14.686c9.073-9.072,14.684-21.609,14.684-35.459S105.973,35.054,96.899,25.98L96.899,25.98z" />
                </svg>
            )
        }
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Ecommerce Item List</h1>
                    <Tooltip title="SpotERP Docs" >
                        <a
                            href={`${process.env.REACT_APP_SPOTERP_DOCS}/ecommerce/item`}
                            className='btn btn-light-primary py-2 px-3'
                            target="_blank"
                        >
                            <i className="bi bi-journal-text fs-1 px-0"></i>
                        </a>
                    </Tooltip>
                </div>
                <div>
                    {
                        state == 1 ?
                            <div className="card mb-5 mb-xl-8">
                                <div className="card-body py-3">
                                    <div className="mb-5"><input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' /></div>

                                    <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                        {
                                            itemsListApiState ?
                                                <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                :
                                                itemList.length > 0 ?
                                                    <>
                                                        <div className="mb-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                showQuickJumper={true}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                            />
                                                        </div>

                                                        <div className='overflow-auto w-100 flex-grow-1'>
                                                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" >
                                                                <thead>
                                                                    <tr className="fw-bold text-muted">
                                                                        <th className="min-w-150px">Item Name</th>
                                                                        <th className="min-w-150px">Category</th>
                                                                        <th className="min-w-150px">Sub-Category</th>
                                                                        <th className="min-w-150px">Brand</th>
                                                                        <th className="min-w-150px">B2B</th>
                                                                        <th className="min-w-150px">B2C</th>
                                                                        <th className="min-w-150px">Status</th>
                                                                        <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        itemList.map((obj) => {
                                                                            return (
                                                                                <tr key={obj.product_id}>
                                                                                    <td><span className="text-dark fw-bold d-block mb-1 fs-6">{obj.product_name}</span></td>
                                                                                    <td><span>{obj.category_name}</span></td>
                                                                                    <td><span>{obj.subcategory_name}</span></td>
                                                                                    <td><span>{obj.brand_name}</span></td>
                                                                                    <td>{getStatus(obj.b2b)}</td>
                                                                                    <td>{getStatus(obj.b2c)}</td>
                                                                                    <td><StatusBadge status={obj.add_status} entity={""} /></td>
                                                                                    <td className="sticky-column">{obj.actions}</td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="mt-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                                showQuickJumper={true}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                                                        <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                                            Need Help <i className="bi bi-question-circle fs-1"></i>
                                                                                        </button> */}
                                                    </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            state == 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Modal show={statusModalShow} onHide={() => { handleStatusModalClose() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Change Status</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleStatusModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is : {status == "Active" ? <span className="fs-5 fw-bolder text-success"> Active </span> : <span className="fs-5 fw-bolder text-danger"> Deactivated </span>}
                            <h3>Are you sure about changing status?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { handleStatusModalClose() }}>Cancel</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Update</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={marketingInfoModalShow} onHide={() => { handleMarketingInfoModalClose(); }} centered>
                <Modal.Header>
                    <Modal.Title>Manage Marketing Configuration</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleMarketingInfoModalClose(); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {
                        marketingInfoApiState ? <div className="text-center"><div className="spinner-border text-success" role="status"></div></div> :
                            <div className="container">

                                <div className="row mb-5 gx-0">
                                    <div className="col-6 px-1">
                                        <label className="fs-5 fw-bold mb-2">Business to Business</label>
                                    </div>
                                    <div className="col-6 px-1">
                                        <div className="form-check form-switch form-check-custom form-check-solid">
                                            <input type="checkbox" className="form-check-input" checked={ecommb2b} onChange={(e) => { setEcommb2b(e.target.checked) }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-5 gx-0">
                                    <div className="col-6 px-1">
                                        <label className="fs-5 fw-bold mb-2">Business to Customer</label>
                                    </div>
                                    <div className="col-6 px-1">
                                        <div className="form-check form-switch form-check-custom form-check-solid">
                                            <input type="checkbox" className="form-check-input" checked={ecommb2c} onChange={(e) => { setEcommb2c(e.target.checked) }} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={() => { handleMarketingInfoModalClose() }}>Close</button>
                    {
                        write &&
                        <button type="button" className="btn btn-lg btn-info" data-kt-indicator={marketingInfoModalSubmitButtonState ? "on" : "off"} disabled={marketingInfoModalSubmitButtonState} onClick={() => { configureProductMarketingInfoSubmit() }}>
                            <span className="indicator-label">Save</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>
        </>);
};

export default EcommerceItemList;
